export default __webpack_public_path__ + "static/Informacion_de_Polizas-5f06d55198df924c2acc4c7aa0fb184e.png";